module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot3-2998de94ee829835fef3a0bf46509baa.png";